import { useMutation } from "@tanstack/react-query"
import { FiUserCheck } from "react-icons/fi"

import { ImpersonationService } from "@/client"
import type { ApiError } from "@/client/core/ApiError"
import useCustomToast from "@/hooks/useCustomToast"
import { handleError } from "@/utils"
import { MenuItem } from "../ui/menu"

interface ImpersonateUserProps {
  userId: string
  canImpersonate?: boolean
}

const ImpersonateUser = ({
  userId,
  canImpersonate = false,
}: ImpersonateUserProps) => {
  const { showSuccessToast } = useCustomToast()

  const mutation = useMutation({
    mutationFn: () =>
      ImpersonationService.startImpersonation({
        requestBody: { user_id: userId },
      }),
    onSuccess: (data) => {
      // Update the token in localStorage
      localStorage.setItem("access_token", data.access_token)

      showSuccessToast("Now impersonating user")

      // Reload immediately to refresh all state with new token
      // Do NOT invalidate queries before reload to avoid race conditions
      window.location.reload()
    },
    onError: (err: ApiError) => {
      handleError(err)
    },
  })

  if (!canImpersonate) {
    return null
  }

  return (
    <MenuItem
      value="impersonate"
      onClick={() => mutation.mutate()}
      color="orange.500"
      _hover={{ bg: "orange.50" }}
    >
      <FiUserCheck />
      Impersonate
    </MenuItem>
  )
}

export default ImpersonateUser
